var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.534 22H8C5.79086 22 4 20.2091 4 18V6C4 3.79086 5.79086 2 8 2H16C18.2091 2 20 3.79086 20 6V13.5769V14.6V15.2457C20 15.7041 19.8425 16.1486 19.554 16.5048L15.7022 21.259C15.3224 21.7277 14.7514 22 14.1482 22H13.625H12.534ZM15.625 18.1772V16.6H16.9028L15.625 18.1772ZM8 20C6.89543 20 6 19.1046 6 18V6C6 4.89543 6.89543 4 8 4H16C17.1046 4 18 4.89543 18 6V14.6H15.625C14.5204 14.6 13.625 15.4954 13.625 16.6V20H8ZM13 9.5L13.4 9.8C13.8418 10.1314 14.4686 10.0418 14.8 9.6C15.1314 9.15817 15.0418 8.53137 14.6 8.2L12.6081 6.70606C12.4396 6.57682 12.2288 6.5 12 6.5C11.7712 6.5 11.5604 6.57682 11.3919 6.70606L9.4 8.2C8.95817 8.53137 8.86863 9.15817 9.2 9.6C9.53137 10.0418 10.1582 10.1314 10.6 9.8L11 9.5V13.3886C11 13.9409 11.4477 14.3886 12 14.3886C12.5523 14.3886 13 13.9409 13 13.3886V9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportLeads);
export default __webpack_public_path__ + "static/media/ImportLeads.d73ac280e00dc9dab34fcfab89e24973.svg";
export { ForwardRef as ReactComponent };